import { Brand, Endpoints } from "@plutoxyz/frame-js";
import { create } from "zustand";

interface DemoStore {
  script: string;
  initialized: boolean;
  setScript: (script: string) => void;
  setInitialized: (initialized: boolean) => void;
  setBrand: (brand: Brand) => void;
  brand: Brand;
  endpoints: Endpoints;
  setEndpoints: (endpoints: Endpoints) => void;
}

export const useDemoStore = create<DemoStore>((set) => ({
  script: "",
  initialized: false,
  brand: {
    logo: "https://storage.googleapis.com/pluto-brand-assets/assets/default-app.svg",
    name: "App Name",
  },
  endpoints: {
    frame: "",
    notary: "",
    socket: "",
  },
  setEndpoints: (endpoints: Endpoints) => set({ endpoints }),
  setScript: (script: string) => set({ script }),
  setInitialized: (initialized: boolean) => set({ initialized }),
  setBrand: (brand: Brand) => set({ brand }),
}));
